import React from 'react';
import { injectImageResolution, pathJoin, getMediaHost, get } from '../../utils';
import RouterLink from '../atoms/RouterLink';
import LazyPicture from '../atoms/LazyPicture';
import { tealiumClickFunc, tealiumMergeClickData, getLastPartInURL } from '../../utils/tealium';
const ResultItem = /*#__PURE__*/React.memo(_ref => {
  let {
    item,
    language,
    analitycs,
    params
  } = _ref;
  const {
    url
  } = item;
  const englishTitleforAnalytics = get(item, '_highlightResult.englishtitle.value', '') || '';
  const renderImage = () => {
    if (!item.headerimage && !item.image) return null;
    const imgSrc = injectImageResolution(`${pathJoin([getMediaHost(), item.headerimage ? item.headerimage.src : item.image])}`, 340, 255);
    const linkText = item.headerimage ? item.headerimage.alt || ' ' : item.introText || ' ';
    return /*#__PURE__*/React.createElement(RouterLink, {
      ariaLabel: linkText,
      href: url,
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickData(analitycs.bannerClickAnalytics, params), getLastPartInURL(url));
      }
    }, /*#__PURE__*/React.createElement(LazyPicture, {
      useEmptyPlaceholder: true
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 991px)",
      srcSet: imgSrc
    }), /*#__PURE__*/React.createElement("img", {
      className: "news__media-img",
      src: imgSrc,
      alt: linkText
    })));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-4 col-lg-4 col-xl-3 legislation-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: `news__item ${!item.headerimage && !item.image ? 'news__item--no-image' : ''}`
  }, renderImage(), /*#__PURE__*/React.createElement("div", {
    className: "news__info-container"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "news__info-label-cnt"
  }, /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, item.categoryTag && item.categoryTag.length ? item.categoryTag.join(', ') : item.category || item.announcementtype || item.businessunit)), /*#__PURE__*/React.createElement("div", {
    className: "news__author"
  }, item.author), /*#__PURE__*/React.createElement("p", {
    className: "body-medium news__title"
  }, item.url && /*#__PURE__*/React.createElement(RouterLink, {
    href: url,
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(analitycs.listingItemAnalytics, params), englishTitleforAnalytics);
    }
  }, item.pagetitle || item.title)), /*#__PURE__*/React.createElement("p", {
    className: "news_pageintro"
  }, item.pageintro))));
});
export default ResultItem;